export const MIN_YEAR = 2018
export const MAX_YEAR = 2026
export const THEMATA_YEAR = 2026
export const SCHEDULE_YEAR = 2027
